// extracted by mini-css-extract-plugin
export default {"button":"ZIqy4ScUKb6QdqOKDqRK","focused":"z_pK9gv_WrSXPNnIB1bU","icon":"YFXQ09qhDq1Qlv4LIuuY","profilelist":"kNJII1QyJWt3M0lsgw2a","digitfocus":"rUlcWU7N4Ooid9Tgrb0X"};